var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalUdhaarGiven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M23.471,37.229V18.671l-4.801,4.801c-0.791,0.791-2.078,0.791-2.869,0c-0.396-0.396-0.594-0.939-0.594-1.436 c0-0.543,0.197-1.039,0.594-1.434l8.264-8.264c0.396-0.396,0.891-0.596,1.436-0.596c0.543,0,1.039,0.199,1.435,0.596l8.265,8.264 c0.793,0.791,0.793,2.078,0,2.869c-0.791,0.791-2.078,0.791-2.869,0l-4.802-4.801v18.557c0,1.141-0.891,2.029-2.026,2.029 C24.362,39.257,23.471,38.366,23.471,37.229z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUdhaarGiven);
export default __webpack_public_path__ + "static/media/TotalUdhaarGiven.88d8ead4aa3f4f39a87dcc3663c5cbc5.svg";
export { ForwardRef as ReactComponent };